import { httpError } from "store/httpError.js";
import "regenerator-runtime/runtime";
import * as util from "lib/util.js";
import debounce from "lodash/debounce";
import getProductTreeId from "../../utils/getProductTreeId";

let debounceGetPanelSearchResults = debounce((context, url) => {
  PubSub.publish("requestout", null);
  context.dispatch("setState", { property: "is_results_loading", value: true });
  return fetch(
    context.state.kb_rest_server + "/kb/jrest/getPanelSearchResults",
    {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: url,
    }
  )
    .then((response) => {
      if (!response.ok) {
        httpError(response, context);
        throw Error();
      }
      return response.json();
    })
    .then((data) => {
      context.commit("search", data.searchResults);
    })
    .catch(function (error) {})
    .finally(function () {
      context.dispatch("setState", {
        property: "is_results_loading",
        value: false,
      });
      PubSub.publish("requestin", null);
    });
}, 500);

let debounceGetPanelPubSearchResults = debounce((context, url) => {
  PubSub.publish("requestout", null);
  context.dispatch("setState", { property: "is_results_loading", value: true });
  return fetch(
    context.state.kb_rest_server + "/kb/jrest/getPanelPubSearchResults",
    {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: url,
    }
  )
    .then((response) => {
      if (!response.ok) {
        httpError(response, context);
        throw Error();
      }
      return response.json();
    })
    .then((data) => {
      context.commit("setPubSearchResults", data.pubSearchResults);
    })
    .catch(function (error) {})
    .finally(function () {
      context.dispatch("setState", {
        property: "is_results_loading",
        value: false,
      });
      PubSub.publish("requestin", null);
    });
}, 800);

export default {
  setLanguage(context, payload) {
    context.commit("setLanguage", payload);
  },
  setStrings(context, payload) {
    context.commit("setStrings", payload);
  },
  setState(context, payload) {
    context.commit("setState", payload);
  },
  touch(context) {
    context.commit("touch");
  },
  restoreDefaults(context) {
    context.commit("restoreDefaults");
  },
  getConfiguredLangs(context) {
    PubSub.publish("requestout", null);
    fetch(context.state.kb_rest_server + "/kb/jrest/getLanguages")
      .then(
        function (response) {
          if (!response.ok) {
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        context.commit("setState", { property: "global_langs", value: data });
        for (var i = 0; i < data.length; i++) {
          if (data[i].langCode == context.state.langCode) {
            context.commit("setState", {
              property: "current_lang_object",
              value: data[i],
            });
          }
        }
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },

  // ---------------------- Auth --------------------------------------

  getAuthInfo(context) {
    PubSub.publish("requestout", null);
    fetch(context.state.kb_rest_server + "/kb/jrest/getAuthInfo")
      .then(
        function (response) {
          if (!response.ok) {
            // have to get a user to login
            context.commit("setState", {
              property: "auth_info_failed",
              value: true,
            });
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.userName === undefined || data.userName == "") {
          context.commit("setState", {
            property: "auth_info_failed",
            value: true,
          });
        } else {
          this.legacyHandleAuthData(context, data);
        }
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },

  legacyHandleAuthData(context, data) {
    // if (!(data.accessType === "Reader" && data.authMode === "Login")) {
    //   context.dispatch("logout");
    // } else {
    //  console.log(JSON.stringify(data));
    if (data.userName) {
      //then already logged in
      context.commit("setState", {
        property: "kb_user",
        value: {
          username: data.userName,
          password: data.password,
          modeId: data.modeId,
        },
      });
      context.commit("setState", {
        property: "last_username",
        value: data.userName,
      });
      context.dispatch("getCommentPermissions");
    } else {
      switch (data.authMode.toLowerCase()) {
        case "auto":
          //getAuthInfo will have updated the session so just record kb user info
          var tmp = context.commit("setState", {
            property: "kb_user",
            value: {
              username: data.userName,
              password: data.password,
              modeId: data.modeId,
            },
          });
          context.commit("setState", {
            property: "last_username",
            value: data.userName,
          });
          break;
        case "sso":
          //Redirect to authUri
          window.location = data.authUri;
          break;
        case "login":
          //do nothing, login dialog will display
          break;
      }
    }
    context.commit("setState", {
      property: "auth_method",
      value: data.authMode,
    });
    // }
  },

  autofill(context) {
    context.dispatch("setState", {
      property: "has_autofill",
      value: true,
    });
    // context.dispatch("login", {
    //   username: process.env.USER,
    //   password: process.env.PASSWORD,
    // });
  },

  setUserDataInStore(context, data) {
    context.commit("setState", {
      property: "kb_user",
      value: { username: data.userName, password: data.password },
    });
    context.commit("setState", {
      property: "last_username",
      value: data.userName,
    });
    context.commit("setState", {
      property: "auth_method",
      value: data.authMode,
    });
    context.dispatch("getCommentPermissions");
  },

  isUserInReaderGroup(data) {
    // return data.accessType === "Reader" && data.authMode === "Login";
    return data.authMode === "Login";
  },

  autofillHandleAuthData(context, data) {
    if (data?.userName) {
      // check if logged in
      if (this.isUserInReaderGroup(data)) {
        this.setUserDataInStore(context, data);
      } else {
        fetch("/kb/jrest/logout", { method: "post" }).then(() =>
          this.autofill(context)
        );
      }
    } else {
      this.autofill(context);
    }
  },

  // logout(context) {
  //   PubSub.publish("requestout", null);
  //   fetch(context.state.kb_rest_server + "/kb/jrest/logout", { method: "post" })
  //     .then(
  //       function (response) {
  //         if (!response.ok) {
  //           httpError(response, context);
  //           throw Error(); //to bail out of promise chain
  //         }
  //         return response;
  //       }.bind(this)
  //     )
  //     .then((response) => {
  //       context.commit("setState", { property: "kb_user", value: null });
  //     })
  //     .catch(function (response) {
  //       console.log(response);
  //     })
  //     .finally(function () {
  //       PubSub.publish("requestin", null);
  //       window.location.reload();
  //     });
  // },

  redirectToSSOLogin() {
    let pathname = window.location.pathname;
    let searchString = window.location.search || "";
    var compRedir = encodeURIComponent("?redir=" + pathname + searchString);
    var redir = encodeURI("/kb/jrest/loginReaderIDP" + compRedir);
    window.location =
      "/lwa/jrest/Auth/IDPLogin?appId=kb&idpclient=choose&redirecturi=" + redir;
  },

  logout(context) {
    PubSub.publish("requestout", null);
    fetch(context.state.kb_rest_server + "/kb/jrest/logout", { method: "post" })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.redirectToSSOLogin()
        PubSub.publish("requestin", null);
      });
  },

  async getItem(context, payload) {
    PubSub.publish("requestout", null);
    try {
      const response = await fetch(
        context.state.kb_rest_server +
          "/kb/jrest/getTree?externalId=" +
          payload.externalId +
          "&langCode=" +
          payload.langCode
      );

      if (!response.ok) {
        if (response.status == 404) {
          context.commit("setState", {
            property: "show_not_found",
            value: true,
          });
          throw Error();
        }

        httpError(response, context);
        throw Error();
      }

      const data = await response.json();
      context.commit("setState", { property: "item", value: data });
    } catch (e) {
      console.log(e);
    } finally {
      PubSub.publish("requestin", null);
    }
  },
  getParentPath(context, payload) {
    PubSub.publish("requestout", null);
    fetch(
      context.state.kb_rest_server +
        "/kb/jrest/getParentPath?externalId=" +
        payload.extId +
        "&langCode=" +
        context.state.langCode
    )
      .then(
        function (response) {
          if (!response.ok) {
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        context.commit("getParentPath", data);
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  getHelpsetTOC(context, payload) {
    PubSub.publish("requestout", null);
    var tmp = payload;
    //fetch("https://localhost:8443/kb/big-toc.json")
    fetch(
      context.state.kb_rest_server +
        "/kb/jrest/getHelpsetTOC?helpsetExtId=" +
        payload.externalId +
        "&langCode=" +
        payload.langCode
    )
      .then(
        function (response) {
          if (!response.ok) {
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        context.commit("getHelpsetTOC", data);
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  async getMimeTypes(context) {
    PubSub.publish("requestout", null);
    try {
      const response = await fetch(
        context.state.kb_rest_server +
          `/kb/jrest/Util/getGlobalSetting?propName=kb.view.mimetypes`
      );
      if (!response.ok) {
        httpError(response, context);
        throw Error(); //to bail out of promise chain
      }
      const mimeTypes = await response.text();
      context.commit("setState", {
        property: "mime_types",
        value: mimeTypes,
      });
    } catch (e) {
      console.log(e);
    } finally {
      PubSub.publish("requestin", null);
    }
  },
  async getPublications(context, payload) {
    let params = new URLSearchParams({
      itemExtId: payload.itemExtId,
      showDescendants: payload.showDescendants,
    });
    PubSub.publish("requestout", null);
    try {
      const response = await fetch(
        context.state.kb_rest_server +
          `/kb/jrest/getPublications?${params.toString()}`
      );
      if (!response.ok) {
        httpError(response, context);
        throw Error(); //to bail out of promise chain
      }
      const publications = await response.json();
      context.commit("setPublications", publications);
    } catch (e) {
      console.log(e);
    } finally {
      PubSub.publish("requestin", null);
    }
  },
  async getCategories(context) {
    PubSub.publish("requestout", null);
    try {
      const response = await fetch(
        context.state.kb_rest_server + "/kb/jrest/getTree?catOnly=true"
      );
      if (!response.ok) {
        httpError(response, context);
        throw new Error(response.statusText); //to bail out of promise chain
      }
      const categories = await response.json();
      context.commit("setCategories", categories);
    } catch (e) {
      console.log(e);
    } finally {
      PubSub.publish("requestin", null);
    }
  },

  async getLangTree(context) {
    PubSub.publish("requestout", null);
    try {
      const response = await fetch(
        context.state.kb_rest_server +
          `/kb/jrest/getLangTree?externalId=ROOT&langCode=${context.state.langCode}`
      );
      if (!response.ok) {
        httpError(response, context);
        throw new Error(response.statusText); //to bail out of promise chain
      }
      const itemLangTree = await response.json();
      context.commit("setItemLangTree", itemLangTree);
    } catch (e) {
      console.log(e);
    } finally {
      PubSub.publish("requestin", null);
    }
  },

  async getPanelControls(context) {
    let panelControlDefs = await this.getPanelControlDefs(context);
    if (panelControlDefs) {
      let controlDefData = await Promise.all(
        panelControlDefs.map((def) => this.getControlDefData(context, def.id))
      );
      context.commit("setControlDefData", controlDefData);
    }
  },
  // Property Filter Panel Actions
  getPanelControlDefs(context) {
    PubSub.publish("requestout", null);
    return fetch(
      context.state.kb_rest_server +
        "/kb/jrest/getPanelControlDefs?panelName=KbSearchPanel"
    )
      .then((response) => {
        if (!response.ok) {
          httpError(response, context);
          throw Error();
        }
        return response.json();
      })
      .then((data) => {
        context.commit("setPanelControlDefs", data);
        return data;
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  getControlDefData(context, payload) {
    PubSub.publish("requestout", null);
    let publicationStr = "";
    let productTreeId = getProductTreeId(context.state.panel_control_defs);
    if (payload === productTreeId) {
      publicationStr = context.state.filter_helpset_id
        ? `&publicationExtId=${context.state.filter_helpset_id}`
        : "";
    }
    return fetch(
      context.state.kb_rest_server +
        `/kb/jrest/getControlDefData?controlId=${payload}&langCode=${context.state.langCode}` +
        publicationStr
    )
      .then((response) => {
        if (!response.ok) {
          httpError(response, context);
          throw Error();
        }
        return response.json();
      })
      .then((data) => {
        return data;
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  updatePropertyFilterState(context, payload) {
    context.commit("setPropertyFilterState", payload);
  },
  updateJSon(context, payload) {
    context.commit("setPanelJSonData", payload);
    this.getPanelSearchResults(context);
  },
  getPanelSearchResults(context) {
    window.scrollTo(0, 0);
    debounceGetPanelSearchResults(context, util.getSearchResultsURL(true));
  },
  getAdjacentPanelSearchResults(context) {
    window.scrollTo(0, 0);
    debounceGetPanelSearchResults(context, util.getSearchResultsURL(false));
  },
  getPanelPubSearchResults(context) {
    let panelControlDefsJSon = JSON.stringify(
      util.controlValuesToLstValues(context.state.control_values)
    );
    let url = `panelControlDefsJSon=${panelControlDefsJSon}&panelName=KbPanel&langCode=${
      context.state.langCode
    }&startRow=${
      (context.state.current_results_page - 1) * context.state.max_results + 1
    }&totRows=${context.state.max_results}`;
    // fetch(context.state.kb_rest_server + "/kb/jrest/getPanelPubSearchResults", {
    //   method: "post",
    //   headers: {
    //     "Content-Type": "application/x-www-form-urlencoded",
    //   },
    //   body: url,
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       httpError(response, context);;
    //       throw Error();
    //     }
    //     return response.json();
    //   })
    //   .then((data) => {
    //     context.commit("setPubSearchResults", data.pubSearchResults);
    //   })
    //   .catch(function (error) {})
    //   .finally(function () {
    //     PubSub.publish("requestin", null);
    //   });
    window.scrollTo(0, 0);
    debounceGetPanelPubSearchResults(context, url);
  },
  // -------
  getTopicHtmlBody(context, payload) {
    PubSub.publish("requestout", null);
    var kbrid = payload;
    fetch(this.state.kb_rest_server + "/kb/jrest/getHtmlBody?kbrid=" + payload)
      .then(
        function (response) {
          if (!response.ok) {
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        context.commit("topicHtmlBody", { kbrid: kbrid, html: data });
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  search(context, payload) {
    PubSub.publish("requestout", null);
    //fetch(context.state.kb_rest_server + "/kb/searchresults.json")
    fetch(
      "/kb/jrest/search?langCode=" +
        payload.langCode +
        "&itemExtId=" +
        payload.externalId +
        "&startRow=1&maxCount=100&searchWords=" +
        payload.searchterm
    )
      .then(
        function (response) {
          if (!response.ok) {
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        //temp until sarch endpoint working
        var tmp = JSON.parse(data);
        context.commit("search", tmp.searchResults);
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  addOrderItem(context, payload) {
    var cart = null;
    cart = JSON.parse(JSON.stringify(context.state.partcart));
    cart.push(payload);
    context.commit("addOrderItem", cart);
  },
  getCommentPermissions(context) {
    PubSub.publish("requestout", null);
    fetch(
      context.state.kb_rest_server + "/kb/jrest/getCommentUserPermissions",
      {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "",
      }
    )
      .then(
        function (response) {
          if (!response.ok) {
            httpError(response, context);
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        context.commit("setState", {
          property: "comment_permissions",
          value: data,
        });
      })
      .catch(function (error) {})
      .finally(function () {
        PubSub.publish("requestin", null);
      });
  },
  shortcutExtId(context, payload) {
    context.commit("setShortcutExtId", payload);
  },
};
